import { useState, useEffect, useRef } from "react";
import { HomePageData } from "../../Data/HomePageData";
import { GetTranlatedValue } from "../../Data/LanguageContext";
import play from "../../../Assets/play.png";

const StarRating = ({ count }) => (
  <div style={{ display: "flex", gap: "4px" }}>
    {Array.from({ length: Math.floor(count) }).map((_, i) => (
      <svg key={i} width="18" height="18" viewBox="0 0 24 24" fill="#FFD700">
        <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
      </svg>
    ))}
    {count % 1 !== 0 && (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="#FFD700">
        <defs>
          <linearGradient id="halfStar" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="50%" stopColor="#FFD700" />
            <stop offset="50%" stopColor="#555" />
          </linearGradient>
        </defs>
        <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" fill="url(#halfStar)" />
      </svg>
    )}
  </div>
);

const PlayButton = ({ onClick, size = 52 }) => (
  <span
    onClick={onClick}
    style={{
      width: size,
      height: size,
      borderRadius: "50%",
      background: "linear-gradient(135deg, #16b287, #2c5363)",
      border: "none",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 4px 15px rgba(22,178,135,0.4)",
      transition: "transform 0.2s ease",
    }}
    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
  >
    <svg width={size * 0.45} height={size * 0.45} viewBox="0 0 24 24" fill="white">
      <polygon points="5,3 19,12 5,21" />
    </svg>
  </span>
);

const VideoModal = ({ testimonial, onClose }) => {
  const isYouTube = testimonial.videoSrc.includes("youtube.com") || testimonial.videoSrc.includes("youtu.be");

  const getYouTubeEmbedUrl = (url) => {
    let videoId = "";
    if (url.includes("youtube.com/shorts/")) {
      videoId = url.split("/shorts/")[1].split("?")[0];
    } else if (url.includes("youtube.com/watch?v=")) {
      videoId = url.split("v=")[1].split("&")[0];
    } else if (url.includes("youtu.be/")) {
      videoId = url.split("youtu.be/")[1].split("?")[0];
    }
    return videoId ? `https://www.youtube.com/embed/${videoId}?autoplay=1&playsinline=1&rel=0&modestbranding=1` : url;
  };

  const embedUrl = isYouTube ? getYouTubeEmbedUrl(testimonial.videoSrc) : null;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.95)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#0f1c24",
          borderRadius: 24,
          width: "min(95vw, 820px)",
          overflow: "hidden",
          boxShadow: "0 20px 60px rgba(0,0,0,0.8)",
        }}
      >
        <div style={{ background: "#000", position: "relative" }}>
          {isYouTube ? (
            <iframe
              src={embedUrl}
              title={`${testimonial.name}'s Testimonial`}
              style={{ width: "100%", height: "460px", border: "none" }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          ) : (
            <video controls autoPlay playsInline style={{ width: "100%", height: "auto", maxHeight: "520px", display: "block" }}>
              Your browser does not support the video tag.
            </video>
          )}
        </div>

        <div style={{ padding: "28px 32px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 16 }}>
            <div
              style={{
                width: 70,
                height: 70,
                borderRadius: "50%",
                background: `linear-gradient(135deg, ${testimonial.color}, #16b287)`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 28,
                fontWeight: 800,
                color: "white",
                flexShrink: 0,
              }}
            >
              {testimonial.avatar}
            </div>
            <div>
              <h3 style={{ color: "white", margin: 0, fontSize: 20 }}>{testimonial.name}</h3>
              <p style={{ color: "#888", margin: "4px 0 0", fontSize: 14 }}>
                {testimonial.role} • {testimonial.location}
              </p>
            </div>
          </div>

          <p style={{ color: "#ddd", lineHeight: 1.7, fontSize: 15.5, margin: 0 }}>
            "{testimonial.quote}"
          </p>

          <button
            onClick={onClose}
            style={{
              marginTop: 24,
              padding: "12px 32px",
              background: "#16b287",
              color: "white",
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
              fontWeight: 600,
              fontSize: 15,
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#13997a")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "#16b287")}
          >
            Close Video
          </button>
        </div>
      </div>
    </div>
  );
};

const TestimonialCard = ({ testimonial, onClick }) => (
  <div
    onClick={onClick}
    style={{
      background: "white",
      border: "1.5px solid rgba(22, 178, 135, 0.15)",
      borderRadius: 22,
      padding: "24px",
      height: "100%",
      cursor: "pointer",
      transition: "all 0.4s ease",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-8px)";
      e.currentTarget.style.borderColor = `${testimonial.color}88`;
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.borderColor = "rgba(22, 178, 135, 0.15)";
    }}
  >
    <div
      style={{
        height: 175,
        borderRadius: 18,
        background: `linear-gradient(145deg, ${testimonial.color}22, #f8f9fa)`,
        position: "relative",
        marginBottom: 20,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <PlayButton size={52} onClick={onClick} />

      <div
        style={{
          position: "absolute",
          bottom: 12,
          right: 12,
          background: "rgba(0,0,0,0.7)",
          color: "white",
          padding: "3px 10px",
          borderRadius: 5,
          fontSize: 11.5,
        }}
      >
        ▶ {testimonial.duration}
      </div>
    </div>

    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
        <div>
          <h4 style={{ color: "#1a2533", margin: 0, fontSize: 16.5, fontWeight: 600 }}>
            {testimonial.name}
          </h4>
          <p style={{ color: "#666", fontSize: 13, marginTop: 4, marginBottom: 0 }}>
            {testimonial.role} • {testimonial.location}
          </p>
        </div>
        <StarRating count={testimonial.rating} />
      </div>

      <p
        style={{
          color: "#444",
          lineHeight: 1.65,
          fontSize: 14.5,
          marginBottom: 16,
          display: "-webkit-box",
          WebkitLineClamp: 4,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}
      >
        "{testimonial.quote}"
      </p>
      <p
        style={{
          color: "#444",
          lineHeight: 1.65,
          fontSize: 14.5,
          marginBottom: 16,
          display: "-webkit-box",
          WebkitLineClamp: 4,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}
      >
        "{testimonial.quotehindi}"
      </p>

      {/* <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span
          style={{
            background: `${testimonial.color}15`,
            color: testimonial.color,
            padding: "6px 14px",
            borderRadius: 20,
            fontSize: 12.5,
            fontWeight: 600,
          }}
        >
          {testimonial.highlight}
        </span>
      </div> */}
    </div>
  </div>
);

const TestimonialSection = ({ data, title }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [modalTestimonial, setModalTestimonial] = useState(null);
  const [cardWidth, setCardWidth] = useState(0);
  const [cardsToShow, setCardsToShow] = useState(3);

  const sliderRef = useRef(null);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const currentTranslate = useRef(0);
  const prevTranslate = useRef(0);
  const animationFrame = useRef(null);

  const updateCardsToShow = () => {
    const width = window.innerWidth;
    if (width < 768) return 1;
    if (width < 1024) return 2;
    return 3;
  };

  const calculateCardWidth = () => {
    const cardElement = document.querySelector(".testimonial-card-wrapper");
    if (cardElement) {
      const gap = 24;
      setCardWidth(cardElement.offsetWidth + gap);
    }
  };

  // Update cards to show on resize
  useEffect(() => {
    const handleResize = () => {
      const newCardsToShow = updateCardsToShow();
      setCardsToShow(newCardsToShow);
      setCurrentIndex(0);
    };

    setCardsToShow(updateCardsToShow());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Calculate card width after render
  useEffect(() => {
    const timeout = setTimeout(calculateCardWidth, 150);
    window.addEventListener("resize", calculateCardWidth);
    return () => {
      clearTimeout(timeout);
      window.removeEventListener("resize", calculateCardWidth);
    };
  }, [cardsToShow, currentIndex]);

  const maxIndex = data?.length - cardsToShow;

  const goPrev = () => setCurrentIndex((prev) => Math.max(0, prev - 1));
  const goNext = () => setCurrentIndex((prev) => Math.min(maxIndex, prev + 1));

  const showArrows = cardsToShow < data?.length;

  // ====================== TOUCH SWIPE LOGIC ======================

  const updateSliderPosition = () => {
    if (sliderRef.current) {
      sliderRef.current.style.transition = "transform 0.4s cubic-bezier(0.25, 0.1, 0.25, 1)";
      sliderRef.current.style.transform = `translateX(-${currentIndex * cardWidth}px)`;
    }
  };

  // Touch Start
  const handleTouchStart = (e) => {
    if (sliderRef.current) {
      isDragging.current = true;
      startX.current = e.type.includes("mouse") ? e.pageX : e.touches[0].clientX;
      prevTranslate.current = currentTranslate.current;

      sliderRef.current.style.transition = "none";
    }
  };

  // Touch Move
  const handleTouchMove = (e) => {
    if (!isDragging.current) return;

    const currentX = e.type.includes("mouse") ? e.pageX : e.touches[0].clientX;
    const diff = currentX - startX.current;
    currentTranslate.current = prevTranslate.current + diff;

    if (sliderRef.current) {
      sliderRef.current.style.transform = `translateX(${currentTranslate.current}px)`;
    }
  };

  // Touch End
  const handleTouchEnd = () => {
    if (!isDragging.current) return;
    isDragging.current = false;

    const movedBy = currentTranslate.current - prevTranslate.current;

    if (Math.abs(movedBy) > cardWidth * 0.3) {
      if (movedBy > 0) {
        goPrev();
      } else {
        goNext();
      }
    } else {
      // Snap back
      updateSliderPosition();
    }

    currentTranslate.current = -currentIndex * cardWidth;
  };

  // Update position when currentIndex changes
  useEffect(() => {
    updateSliderPosition();
  }, [currentIndex, cardWidth]);

  return (
    <section
      style={{
        background: "linear-gradient(180deg, #effaff 0%, #effaff 50%, #effaff 100%)",
        padding: "100px 20px 100px 20px",
        fontFamily: "system-ui, -apple-system, sans-serif",
      }}
    >
      <div style={{ maxWidth: 1280, margin: "0 auto" }}>
        <div style={{ textAlign: "center" }}>
          {
            title
          }
        </div>

        <div style={{ position: "relative" }}>
          {/* Left Arrow */}
          {showArrows && (
            <span
              className="d-none d-lg-block"
              onClick={goPrev}
              style={{
                position: "absolute",
                left: -42,
                top: "50%",
                transform: "translateY(-50%)",
                width: 54,
                height: 54,
                borderRadius: "50%",
                background: currentIndex === 0 ? "#e0e0e0" : "#16b287",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: currentIndex === 0 ? "not-allowed" : "pointer",
                zIndex: 10,
                fontSize: 22,
                userSelect: "none",
                transition: "background 0.3s ease",
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" style={{ marginLeft: 14, marginTop: 15 }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="m15 18-6-6 6-6" />
              </svg>
            </span>
          )}

          <div style={{ overflow: "hidden", borderRadius: 20 }}>
            <div
              ref={sliderRef}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
              onMouseDown={handleTouchStart}
              onMouseMove={handleTouchMove}
              onMouseUp={handleTouchEnd}
              onMouseLeave={handleTouchEnd}
              style={{
                display: "flex",
                gap: "24px",
                transition: "transform 0.7s cubic-bezier(0.25, 0.1, 0.25, 1)",
                transform: `translateX(-${currentIndex * cardWidth}px)`,
                padding: "11px 1px",
                userSelect: "none",
                WebkitUserSelect: "none",
                touchAction: "pan-y", // Allow vertical scroll but prevent horizontal default
              }}
            >
              {data?.map((t) => (
                <div
                  key={t.id}
                  className="testimonial-card-wrapper"
                  style={{
                    flex: "0 0 auto",
                    width:
                      cardsToShow === 1
                        ? "100%"
                        : `calc(${100 / cardsToShow}% - ${(24 * (cardsToShow - 1)) / cardsToShow}px)`,
                  }}
                >
                  <TestimonialCard testimonial={t} onClick={() => setModalTestimonial(t)} />
                </div>
              ))}
            </div>
          </div>

          {/* Right Arrow */}
          {showArrows && (
            <span
              className="d-none d-lg-block"
              onClick={goNext}
              style={{
                position: "absolute",
                right: -42,
                top: "50%",
                transform: "translateY(-50%)",
                width: 54,
                height: 54,
                borderRadius: "50%",
                background: currentIndex === maxIndex ? "#e0e0e0" : "#16b287",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: currentIndex === maxIndex ? "not-allowed" : "pointer",
                zIndex: 10,
                fontSize: 22,
                userSelect: "none",
                transition: "background 0.3s ease",
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" style={{ marginLeft: 15, marginTop: 15 }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="m9 18 6-6-6-6" />
              </svg>
            </span>
          )}
        </div>

        {/* Dots Navigation */}
        {showArrows && (
          <div style={{ display: "flex", justifyContent: "center", gap: 8, marginTop: 32 }}>
            {Array.from({ length: maxIndex + 1 }).map((_, i) => (
              <span
                key={i}
                onClick={() => setCurrentIndex(i)}
                style={{
                  width: i === currentIndex ? 24 : 8,
                  height: 8,
                  borderRadius: 4,
                  background: i === currentIndex ? "#16b287" : "#ccc",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  display: "inline-block",
                }}
              />
            ))}
          </div>
        )}

        <div style={{ textAlign: "center", marginTop: 60 }}>
          <div className="responsive-btn d-flex justify-content-center gap-2">
            <a
              href={`${window.location.origin}/version2/auth/login`}
              style={{ textDecoration: 'none', backgroundColor: '#00b087', color: "white", padding: '11px 15px' }}
              className="btn mb-2 csp-home-btn d-flex align-items-center px-3 px-lg-4 rounded-pill"
            >
              {GetTranlatedValue(HomePageData?.FIRSTSECTION?.getstarted)}
              <span className="d-flex home-btn-arrow" style={{ transitionDuration: '0.3s' }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-arrow-right-short" viewBox="0 0 16 16">
                  <path fillRule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z" />
                </svg>
              </span>
            </a>
            <a
             title='Download Application'
              href={'https://play.google.com/store/apps/details?id=com.cspindianetwork.app&pcampaignid=web_share'}
              style={{ textDecoration: 'none', backgroundColor: "#fff", border: "1px solid #2c5363" }}
              className="btn mb-2 csp-home-btn d-flex align-items-center px-3 px-lg-4 rounded-pill gap-2"
            >
              <img src={play} style={{ height: 20, width: 20 }}></img>
              <div style={{ display: 'flex', flexDirection: "column", alignItems: "start" }}>
                <span style={{ color: "#000", fontSize: "16px" }}>Google Play</span>
              </div>
            </a>
          </div>
        </div>
      </div>

      {modalTestimonial && (
        <VideoModal
          testimonial={modalTestimonial}
          onClose={() => setModalTestimonial(null)}
        />
      )}
    </section>
  );
};

export default TestimonialSection;